import { NgModule } from '@angular/core';
import { provideDefaultConfig } from '@spartacus/core';
import { defaultSeoConfig } from './config';
import { htmlLangProvider } from './html-lang-provider';
import { StructuredDataModule } from './structured-data/structured-data.module';

@NgModule({
  imports: [StructuredDataModule],
  providers: [
    provideDefaultConfig(defaultSeoConfig),
    htmlLangProvider,
  ],
})
export class SeoModule {}
